import { Injectable } from '@angular/core';
import { FieldAgentClient, QuickPurchase } from 'ep-bt-field-agent-proxy';
import { EpbtFaProductService } from '../services/epbt-fa-product.service';
import { EpbtFaQuickPurchaseLineModel } from '../../lib/models/epbt-fa-quick-purchase-line.model';

@Injectable({
  providedIn: 'root'
})
export class EpbtFaQuickPurchaseService {


  constructor(private client: FieldAgentClient, private productService: EpbtFaProductService) { }

  public quickPurchase: QuickPurchase;

  public quickPurchaseLine: EpbtFaQuickPurchaseLineModel;

  public searchSuppliersString: string;

  //List of products used for QuickPurchase 
  //public selectedProducts: any[] = [];

  //from dashboard or product details flag 
  public fromDashbard: boolean = false;

  public isQuickPurchaseSearch: boolean = false;

  //Validation flag supplier tab
  public supplierFormFlag: boolean = false;

  //public searchFlag: boolean = false;

  //Selected Products Related properties
  public selectedProductsForBinding: EpbtFaQuickPurchaseLineModel[] = [];

  //public selectedProductsForBinding1: EpbtFaQuickPurchaseLineModel[] = [];

  public isNegotiationEdit = false;

  public errorMessage = "";

  public wizardStep: number = 0;

  public isSuppliersSearchMessage = false;

  createQuickPurchaseline() {
    if (this.isQuickPurchaseSearch) {
      let quickPurchaseLine = new EpbtFaQuickPurchaseLineModel(this.productService.selectedProductItem);//QuickPurchaseLine Model
      //lineAdd
      let nextLineNumber: number = 1;
      //let selectedLineIndex: number = 1;
      nextLineNumber = this.selectedProductsForBinding.length + 1;
      //selectedLineIndex = this.lines.length;
      this.quickPurchaseLine = quickPurchaseLine;
      this.quickPurchaseLine.product.dateTimeLastModified = new Date();
      this.quickPurchaseLine.lineNumber = nextLineNumber;
      this.quickPurchaseLine.adding = true;
    }
  }

  clearData() {
    // this.quickPurchaseLine = new EpbtFaQuickPurchaseLineModel();
    this.selectedProductsForBinding = [];
    this.errorMessage = "";
    this.quickPurchase = new QuickPurchase();
    this.isQuickPurchaseSearch = false;
    this.supplierFormFlag = false;
    // this.searchFlag = false;
    this.isNegotiationEdit = false;
    this.searchSuppliersString = "";
    this.wizardStep = 0;
    this.fromDashbard = false;
    this.isSuppliersSearchMessage = false;
  }

  // prepareData() {
  //   this.selectedProductsForBinding1 = [];
  //   this.selectedProductsForBinding.forEach(item => {
  //     this.selectedProductsForBinding1.push(item);
  //   });
  // }
}
